import React, { useState, useEffect } from "react";
import styled from "styled-components";
import CarpetCard from "../components/Carpet/CarpetCard";
import CarpetForm from "../components/Carpet/CarpetForm"; // New component for adding/editing carpets
import { models, sizes } from "../assets/constant";
import { useLocation } from "react-router-dom";

import {fetchCarpetsFromDynamoDB} from "../aws/DynamoDB";

export default function Carpets() {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const querySize = query.get("massen");
    const queryModel = query.get("modelle");
    const queryColor = query.get("farben");
    const queryMaterial = query.get("materialien");
    const queryManufacturing = query.get("herstellungsart");
    const queryDesign = query.get("design");
    const queryUsage = query.get("verwendungszweck");
    const [expandedFilters, setExpandedFilters] = useState({});
    const [selectedFilters, setSelectedFilters] = useState({
        model: queryModel ? [queryModel] : [],
        size: querySize ? [querySize] : [],
        // color: queryColor ? [queryColor] : [],
        // material: queryMaterial ? [queryMaterial] : [],
        // manufacturing: queryManufacturing ? [queryManufacturing] : [],
        // design: queryDesign ? [queryDesign] : [],
        // usage: queryUsage ? [queryUsage] : []
    });
    const [filterTags, setFilterTags] = useState([]);
    useEffect(() => {
        const tags = Object.values(selectedFilters).flat();
        setFilterTags(tags);
    }, [selectedFilters]);

    const [carpets, setCarpets] = useState([]);
    const [sortBy, setSortBy] = useState("date-newest");
    const [searchTerm, setSearchTerm] = useState("");

    const [admin] = useState(!!localStorage.getItem("username")); // Set to false to disable admin mode
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [carpetToEdit, setCarpetToEdit] = useState(null);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const limit = 12;
    const [totalCarpets, setTotalCarpets] = useState(0);



    // Fetch carpets from DynamoDB via your API endpoint
    // Filters, searching, and sorting are all handled server‑side.
    const formatFiltersForQuery = () => {
        return Object.entries(selectedFilters)
            .filter(([_, values]) => values.length > 0) // Remove empty filters
            .map(([key, values]) => `${key}=${values.join(",")}`) // Create OR condition for each category
            .join("&"); // Join with AND condition between categories
    };
    const fetchCarpets = async (page, replace = false) => {
        try {
            const queryParams = formatFiltersForQuery();

            const data = await fetchCarpetsFromDynamoDB(page, searchTerm, queryParams, sortBy, limit);
            // If fewer than the requested limit are returned,
            // assume there are no more carpets to load.
            if (data.page < data.pageCount) {
                setHasMore(true);
            } else {
                setHasMore(false);
            }
            // Replace carpets if fetching a new filtered/sorted list,
            // otherwise append the next page.
            if (replace) {
                setCarpets(data.items);
            } else {
                setCarpets((prev) => [...prev, ...data.items]);
            }
            setTotalCarpets(data.total)
        } catch (error) {
            console.error("Failed to fetch carpets:", error);
        }
    };

    // Reset pagination and fetch when search, filters, or sort changes.
    useEffect(() => {
        setPage(1);
        fetchCarpets(1, true);
    }, [searchTerm, selectedFilters, sortBy]);


    const toggleExpand = (category) => {
        setExpandedFilters((prev) => ({
            ...prev,
            [category]: !prev[category]
        }));
    };
    const toggleSelection = (category, value) => {
        setSelectedFilters((prev) => {
            const updatedSelection = prev[category].includes(value)
                ? prev[category].filter((item) => item !== value) // Remove if already selected
                : [...prev[category], value]; // Add if not selected

            return { ...prev, [category]: updatedSelection };
        });
    };



    const removeTag = (tagToRemove) => {
        setSelectedFilters((prev) => {
            const newFilters = {};
            for (const category in prev) {
                newFilters[category] = prev[category].filter((item) => item !== tagToRemove);
            }
            return newFilters;
        });
    };


    // Open Add/Edit Form
    const openFormNewCarpet  = (carpet = null) => {
        setCarpetToEdit(carpet);
        setIsFormOpen(true);
    };

    const loadMore = () => {
        const newPage = page + 1;
        setPage(newPage);
        fetchCarpets(newPage, false);
    };


    return (
        <Wrapper>
            <Sidebar>
                <FilterWrapper>
                    {/*<h1 className="font18 Bold">Filter</h1>*/}

                    {[{title: "Modelle", key: "model", items: models},
                        // {title: "Materialien", key: "material", items: materials},
                        // {title: "Herstellungsart", key: "manufacturing", items: manufacturing},
                        // {title: "Designs", key: "design", items: designs},
                        // {title: "Verwendungszweck", key: "usage", items: usage},
                        {title: "Maße", key: "size", items: sizes},
                        // {title: "Farben", key: "color", items: colors}
                    ]
                        .map(({ title, key, items }) => (
                            <FilterGroup key={key}>
                                <FilterHeader onClick={() => toggleExpand(key)}>
                                    <span>{title}</span>
                                    <ToggleIcon>{expandedFilters[key] ? "-" : "+"}</ToggleIcon>
                                </FilterHeader>
                                {expandedFilters[key] && (
                                    <FilterList>
                                        {items.map((item) => (
                                            <FilterButton
                                                key={item}
                                                onClick={() => toggleSelection(key, item)}
                                                active={selectedFilters[key].includes(item)}
                                            >
                                                {sizes.includes(item) ? `ca. ${item} cm` : item}

                                            </FilterButton>
                                        ))}
                                    </FilterList>
                                )}
                            </FilterGroup>
                        ))}
                </FilterWrapper>

            </Sidebar>

            <MainContent>
                <TopSection>
                    <h1 className="font40 extraBold">Unsere Teppiche</h1>
                    <p className="font16">
                        Wählen Sie Ihren Teppich aus und kontaktieren Sie uns – bitte geben Sie dabei die Objekt-Nummer des gewünschten Teppichs an.
                    </p>
                    <p className="font16">
                        Auf der linken Seite können Sie die Teppiche nach Modelle oder Maße filtern, um die Auswahl einzugrenzen.
                    </p>
                    {admin && (
                        <AddButton onClick={() => openFormNewCarpet (null)}>+ Neuer Teppich</AddButton>
                    )}
                    <SearchSort>
                        <SearchContainer>
                            <SearchInput
                                type="text"
                                placeholder="Nach Name, Beschreibung oder Nummer suchen..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </SearchContainer>
                        <div>
                            {totalCarpets} Teppiche gefunden
                        </div>

                        <SortDropdown>
                            <label>Sortieren nach</label>

                            <select onChange={(e) => setSortBy(e.target.value)} value={sortBy}>
                                <option value="date-newest">Neueste zuerst</option>
                                <option value="date-oldest">Älteste zuerst</option>
                                <option value="price-asc">Preis: Niedrig bis Hoch</option>
                                <option value="price-desc">Preis: Hoch bis Niedrig</option>
                            </select>
                        </SortDropdown>

                    </SearchSort>
                    <FilterTags>
                        {filterTags.map((tag, index) => (
                            <Tag key={index}>
                                {tag} <RemoveTagButton onClick={() => removeTag(tag)}>×</RemoveTagButton>
                            </Tag>
                        ))}
                    </FilterTags>
                </TopSection>

                <CarpetGrid>
                    {carpets.length > 0 ? (
                        <>
                            {carpets.map((carpet) => (
                                <CarpetCard key={carpet.id} carpet={carpet} admin={admin} fetchCarpets={fetchCarpets} />
                                ))
                            }
                        </>


                    ) : (
                       // <NoResults>Keine Teppiche gefunden.</NoResults>
                        <NoResults></NoResults>
                    )}
                </CarpetGrid>
                {hasMore && (
                    <LoadMoreButton onClick={loadMore}>
                        Mehr Teppiche anzeigen
                    </LoadMoreButton>
                )}


            </MainContent>

            {isFormOpen && <CarpetForm carpet={carpetToEdit} fetchCarpets={fetchCarpets} onClose={() => setIsFormOpen(false)} />}
        </Wrapper>
    );
}


const Sidebar = styled.div`
  width: 180px;
  padding: 35px 0 50px 0;
  background: #efefef;
  border-radius: 8px;
  overflow-y: auto;
  max-height: 90vh;

  @media (max-width: 768px) {
    width: 100%;
    max-height: 60vh;
  }
`;

const FilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const FilterGroup = styled.div`
  margin-bottom: 0;
`;

const FilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-size: 17px;
  font-weight: bold;
  padding: 10px;
  background: #ddd;
  border-radius: 5px;
`;

const ToggleIcon = styled.span`
  font-size: 18px;
  font-weight: bold;
`;

const FilterList = styled.div`
  //max-height: 150px;
  //overflow-y: auto;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const FilterButton = styled.button`
  display: block;
  width: 100%;
  font-size: 16px;

  background: ${(props) => (props.active ? "#7620FF" : "#f0f0f0")};
  color: ${(props) => (props.active ? "#fff" : "#000")};
  padding: 7px;
  margin-bottom: 5px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: left;

  :hover {
    background: #580cd2;
    color: #fff;
  }
`;

const FilterTags = styled.div`
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

const Tag = styled.div`
  background: #7620FF;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 18px;
`;
/* Styled Components */
const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 45px;
  overflow-y: auto;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const MainContent = styled.div`
  flex: 1;
  padding: 20px;
`;

const SearchSort = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }
`;

const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SearchInput = styled.input`
  width: 450px;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 16px;
  outline: none;
  text-align: center;
  transition: 0.3s;

  &:focus {
    border: 1px solid #bebdbd;
    box-shadow: 0 0 5px rgba(118, 32, 255, 0.5);
  }

  @media (max-width: 768px) {
    width: 330px;
    font-size: 13px;
  }
`;

const SortDropdown = styled.div`
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: baseline;
  gap: 5px;
  background: #fff;

  //box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
  @media (max-width: 768px) {
    //width: 100%;
    font-size: 13px;
  }
  label {
    font-size: 13px;
    font-weight: 600;
    color: #333;
  }

  select {
    padding: 2px 2px;

    font-size: 13px;
    background: transparent;
    outline: none;
    cursor: pointer;
    font-weight: bold;
    color: #444;
    transition: 0.3s ease;
    border-radius: 8px;
    border: 1px solid #ddd;

    &:hover {
      color: #2a2a2a;
    }
  }
`;


const CarpetGrid = styled.div`
  display: flex;
  //grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  flex-wrap: wrap;
  gap: 15px;
  justify-content: space-evenly;
  @media (max-width: 999px) {
    gap: 20px;
  }
`;

const AddButton = styled.button`
  background-color: #019355;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 18px;
  margin-top: 5px;
  margin-bottom: 10px;

`;

const NoResults = styled.div`
  text-align: center;
  font-size: 16px;
  color: #707070;
`;



const TopSection = styled.div`
  //display: flex;
  //-webkit-box-pack: justify;
  //-webkit-box-align: center;
  //align-items: flex-start;
  margin-bottom: 20px;
  padding: 15px 0 0 0;
  ////background: rgb(249, 249, 249);
  border-radius: 8px;
  //flex-direction: column;
  //justify-content: space-between;
  //flex-wrap: nowrap;
  //align-content: space-between;

  h1 {
    font-size: 28px;
    font-weight: bold;
    margin: 0;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 10px;
  }
`;

const RemoveTagButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
  &:hover {
    color: #ccc;
  }
`;

const LoadMoreButton = styled.button`
  margin: 20px auto 0;
  display: block;
  background: #019355;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 18px;
`;